import Link from "next/link";
import { SIGNUPS_CLOSED_MESSAGE, SIGNUPS_CLOSED_TITLE } from "../../constants/main";

// Formerly the "choose your plan" purchase widget shown over locked content.
// Sign-ups and purchases are closed, so it now only explains the closure and
// points existing members at the login page.
const UpdatePlan = ({ page, showPremium = false }) => {
  const heading =
    page === "bracketBuilder"
      ? "ShotQuality Bracket Builder"
      : page === "matchups"
      ? "ShotQuality Matchups"
      : `ScoreCenter${showPremium ? " Past Games" : ""}`;
  return (
    <div className="p-5 bg-white" style={{ width: "100vw", maxWidth: "1540px", margin: "auto" }} tabIndex="-1">
      <div className="row">
        <div className="col-sm-12 text-center">
          <h2 className="font-weight-bold">{heading} is available to existing members</h2>
          <h4 className="mt-4">{SIGNUPS_CLOSED_TITLE}</h4>
          <p>{SIGNUPS_CLOSED_MESSAGE}</p>
          <p className="mt-4">
            Already a member?{" "}
            <Link href="/login" className="text-primary">
              Sign In
            </Link>
          </p>
        </div>
      </div>
    </div>
  );
};
export default UpdatePlan;
